<template>
	<font-awesome
		:icon="icon"
		:style="{
			color: `${color} !important`,
			height: `${width || height} !important`,
		}"
	/>
</template>

<script>
import { library, config, dom } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as FontAwesome } from "@fortawesome/vue-fontawesome";

library.add(fas, far, fal);
config.autoAddCss = false;

export default {
	name: "FontAwesomeIcon",
	components: {
		FontAwesome,
	},
	props: {
		icon: {
			type: String, // Adjust the type according to your actual icon prop type
			required: true,
		},
		width: {
			type: String,
			required: false,
		},
		height: {
			type: String,
			required: false,
		},
		color: {
			type: String,
			required: true,
		},
	},
	mounted() {
		// Ensure that the shadowRoot exists and avoid remounting
		if (this.$el.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			const shadowRoot = this.$el.getRootNode();
			const id = "fa-styles";

			if (!shadowRoot.getElementById(id)) {
				const faStyles = document.createElement("style");
				faStyles.setAttribute("id", id);
				faStyles.textContent = dom.css();
				shadowRoot.prepend(faStyles);
			}
		}
	},
};
</script>
